export default __webpack_public_path__ + "static/media/Fiore.a1be595f.jpg";